import { useSelector} from "react-redux";
import UserDoneStatus from "./helper/UserDoneStatus";
import { Avatar,Indicator,Group, Grid, Tooltip, Image, createStyles, Title, rem} from '@mantine/core';
import idaustrialogo from '../images/idaustria.png'
import idaustrialogow from '../images/idaustriaw.png'
import { CameraOff} from 'tabler-icons-react';
import intl from "react-intl-universal"; 
import React from "react";

const useStyles = createStyles((theme) => ({
  overdiv: {
    position: 'relative',
    display: 'inline-block',
  },
  posidaustria: {
    position: 'absolute',
    display: 'inline-block',
    top: "-2px",
    left:"-10px",
  },
  guestpos: {
    marginLeft: "15px",
    display: 'inline-block',
  },
  textsize: {
    fontSize: rem('16px'),
    [theme.fn.smallerThan('lg')]: {
      fontSize: rem('10px'),
    },
  }
}));

export function UserInMeeting(props:any) {
/**
 * Renders a list of users in a meeting, displaying their initials, full name, and meeting status.
 *
 * @initparticipants {Object} - state.user.meetinguser - Array of Objects containing the users in the meeting.
 * @meetingszenen {Object} - state.user.meetingszenen - Array of Objects containing Information about the szenes in the meeting.
 * @meetingzenenID {number} - state.user.meetingzenenID - The ID of the current Szene in the meeting.
 * @return {JSX.Element} - the rendered list of users in a meeting
 */
  const { classes } = useStyles();
  const initparticipants = useSelector((state: any) => state.user.meetinguser)
  const meetingszenen = useSelector((state: any) => state.user.meetingszenen)
  const meetingzenenID = meetingszenen[1].scenarioId
  
  // Filter all User that ar not notar
  const datauser = initparticipants.filter((obj: { role: any; }) => {
  return obj.role !== "notar" && obj.role !== "gast"
  });

  const rows = (datauser || []).map((item:any, index:any) => {
      // Make Initialen
      let a = item.lastName.substring(0,1)
      let b = item.firstName.substring(0,1)
      let initialen = a + b
      let fullname = item.lastName + " " + item.firstName 

     let inmeetingcolor = "red"
     if (item.meetingParticipantStatus === null) {
      inmeetingcolor = "red"
    }
     if (item.meetingParticipantStatus === "LeftMeeting") {
       inmeetingcolor = "red"
     }
     if (item.meetingParticipantStatus === "InMeeting") {
       inmeetingcolor = "green"
     }

    const statuslist= item.actions.filter((obj: { scenarioId: any }) => {
      return obj.scenarioId === meetingzenenID
    });

    let identcolor = "gray"
    let identstyle = "outline"

      if(statuslist[0].isDone) {
        identcolor = "green"
        identstyle = "filled"
      } 

    // IDAustria identified true/false  
    let statusidaustria
      if (item.idAustriaData !== null) {
        statusidaustria = item.idAustriaData.isIdentified
      }

    let disablecamera = "1"


 
     return (
      <React.Fragment key={item.id || index}>
      {props.view !== "small" &&
       <> 
     <Grid key={index}>
        <Grid.Col xs={2} md={3} lg={3} xl={2}>
          <Indicator inline size={16} offset={7} position="bottom-end" color={inmeetingcolor} withBorder>
            <Avatar   alt={fullname} variant="filled" radius="xl" size="lg">{initialen} </Avatar>
          </Indicator>
        </Grid.Col>
        <Grid.Col xs={7} md={6} lg={6} xl={7}> 
            <Group>
            <span className={classes.textsize}>{fullname}</span>
            </Group>
        </Grid.Col>
        <Grid.Col xs={3} md={3} lg={3} xl={3}>
            <Group  spacing={5} mt={2} position="right">
               {statusidaustria && item.meetingParticipantStatus === "InMeeting" && 
                <Tooltip label={intl.get('IDA_DATA_CONFIRMED')} multiline={true}>
                    <Image
                    height={20}
                    width={43}
                    src={idaustrialogo}
                      />
                </Tooltip>  
                } 
              {item.isToBeIdentified && disablecamera === "0" &&
              <UserDoneStatus actiondone={item.actions} />
              } 
              {!item.isToBeIdentified && disablecamera === "0" &&
              <Tooltip label={intl.get('GUEST_USERNOTBEIDENT')} >
                 <span>
                <CameraOff size={38} strokeWidth={1} color="gray" />
                </span>
              </Tooltip>
              }
           </Group>
     </Grid.Col>
   </Grid>
     <hr />
    </>
    }



   
    {props.view === "small" &&
      <Grid key={index}>
        <Grid.Col span={12}>
          <Group position="right" >
            <div className={classes.overdiv}>
                <Indicator inline size={12} offset={4} position="bottom-end" color={inmeetingcolor} withBorder>
                  <Avatar color={identcolor} alt={fullname} variant={identstyle} radius="xl" size="md">{initialen} </Avatar>
                </Indicator>
              {statusidaustria && item.meetingParticipantStatus === "InMeeting" && 
                <Tooltip label={intl.get('IDA_DATA_CONFIRMED')} multiline={true}>
                    <Image
                    height={13}
                    width={27}
                      src={idaustrialogow}
                      className={classes.posidaustria}
                      />
                </Tooltip>  
          }
            </div> 
          </Group>
        </Grid.Col>
      </Grid>
    }
   </React.Fragment>
     );
   }); 

   const guestdata = initparticipants.filter((obj: { role: any; meetingParticipantStatus: string; }) => {
    return obj.role === "gast" 
});
   
   const guestrows = (guestdata || []).map((item:any, index:any) => {

    //let a = item.lastName.substring(0,1)
    //let b = item.firstName.substring(0,1)
    //let initialen = "GU"
    //let fullname = item.emailAddress

    const [username, domain] = item.emailAddress.split('@')[0]
    const initials = username[0].toUpperCase() + domain[0].toUpperCase();
    
    let inmeetingcolor = "red"
    if (item.meetingParticipantStatus === null) {
     inmeetingcolor = "red"
    }
    if (item.meetingParticipantStatus === "LeftMeeting") {
     inmeetingcolor = "red"
    }
    if (item.meetingParticipantStatus === "InMeeting") {
     inmeetingcolor = "green"
    }
    
    return (
      <>
      {props.view !== "small" &&
      <div className={classes.guestpos}>
      
      <Indicator inline size={12} offset={4} position="bottom-end" color={inmeetingcolor} withBorder>
        <Avatar  alt={initials} variant="outline"  radius="xl" size="md" >
          {initials} 
        </Avatar> 
      </Indicator>
   
      </div>
      }

    {props.view === "small" &&
     <Group position="right" >
   
      <Indicator inline size={12} offset={4} position="bottom-end" color={inmeetingcolor} withBorder>
        <Avatar  alt={initials} variant="outline"  radius="xl" size="md" >
          {initials} 
        </Avatar> 
      </Indicator>
     
      </Group>
      
      }
      </>
    )
    })


  return (
    <>
      {rows}
      {guestrows.length !== undefined && guestrows.length > 0 && 
      <>
        {props.view !== "small" &&
        <>
           <Title order={3}>{intl.get('USER_VKGUEST_HEAD')}</Title>
           <hr />
          </>
        }
      {guestrows}
        <hr />
      </>
      }
     
    </>
  );
}